import React from 'react';

import { PropertySelectField } from '@paragon/client-tools';
import { LayoutFeatureAreaBase } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

type FeatureAreaType = LayoutFeatureAreaBase['featureType'];

interface Props {
  value: FeatureAreaType;
  onChange: (value: FeatureAreaType) => void;
}

export function FeatureAreaTypeSelect({ value, onChange }: Props) {
  return (
    <PropertySelectField<FeatureAreaType>
      margin="normal"
      property="Feature Type"
      value={value}
      getName={humanCase}
      options={['Chase', 'Step' /* 'BeamPocket', 'VerticalStack' */]}
      submit={onChange}
    />
  );
}
